<template>
	<div class="relative" @mouseover="hovered(true)" @mouseleave="hovered(false)" @click="route(to)">
		<div 
			class=" rectangle m-b-10 is-hoverable"
			ref="parent"
			:class="{colored: isHovered, 'is-center': !top , 'is-top': top}"
			:style="{
				background: `url(${this.background})`,
					'min-height': $mq.resize && $mq.above($mv.tablet) ? height : '50vh',
				}"
		>
		</div>
		<div class="absolute content-style is-hoverable" :class="{hide: isHovered || isClicked, contact: $route.name === 'contact' }" @click="route(to)">
			<h2 v-if="$route.name === 'contact' && !isClicked " @click="isClicked = !isClicked" class="title is-2 is-capitalized no-margin-bottom" :class="red ? 'is-red' : 'is-white'">{{title}}</h2>
			<h2 v-if="$route.name !== 'contact'" class="title is-2 is-capitalized no-margin-bottom" :class="red ? 'is-red' : 'is-white'">{{title}}</h2>
			<h3 v-if="$mq.resize && $mq.above($mv.tablet) && !html" class="subtitle no-margin-top is-white is-5 ">{{subtitle}}
			</h3>
			<h3 v-if="$mq.resize && $mq.above($mv.tablet) && html" class="subtitle is-white is-5 no-margin-top relative" v-html="subtitle">
			</h3>
			<div @click="isClicked = !isClicked" v-if="isClicked && $mq.resize && $mq.below($mv.tablet) && $route.name === 'contact'" class="is-white is-5 no-margin-top relative" v-html="subtitle"></div>
			<slot>
				
			</slot>
		</div>
		<!-- v-if="isButtonHiddenMobile ? $mq.resize && $mq.below($mv.tablet) ? false : !isButtonHidden : false" -->
		<!-- <router-link :to="`/${to}`"> -->
			<button v-if="$route.name !== 'contact'" @click="route(to)" class="is-bold is-white has-gradient-background button" @mouseover="isHovered = true" @mouseleave="isHovered = false">
				<icon name="chevron-right"></icon>
			</button>
		<!-- </router-link> -->
	</div>
</template>
<script>
	export default {
		props: ['background', 'top', 'height', 'title', 'subtitle', 'to', 'isButtonHidden', 'isButtonHiddenMobile' ,'html', 'red', 'email'],
		data() {
			return {
				isHovered: false,
				isClicked: false,
			}
		},
		watch: {
			'background': function(path) {
				if (path !== '#') {
					let url = path;
					
					let loaded = false;
					let img = new Image();
					img.src = url;
					// publish the loading event as a start
					this.$parent.$emit('loading');
					img.onload = () => {
						this.$parent.$emit('loaded');
						loaded = true;
					}
					// if images not loaded after too long, just fire the event regardless 
					setTimeout( () => {
							if (!loaded) {
								this.$parent.$emit('loaded');
							}
					}, 5000 )  
				}
			}
		},
		mounted() {
		},
		methods: {
			hovered(value) {
				// if (this.$route.name !== 'contact') {
					this.isHovered = value;
				// }
			},
			route(to) {
				if (this.$route.name !== 'contact') {
					if (this.email) {
						document.location.href = `mailto:${this.email}`;
					}
					if (to) {
						this.$router.push(`/${to}`);
					}
				} else {
					this.isClicked = !this.isClicked;
				}
			}
		}
	};
</script>
<style lang="scss" scoped>
	h2,h3 {
		// text-shadow: black 6px 0px 12px;
	}
	.is-5 /deep/ {
		* {
			font-size: 16px;
		}
	}
	h2 {
    padding: 0px 10px;
    font-weight: 700;
    transition: .75s ease all;
	}
	.contact {
		flex-direction: column;
		h2 {
			padding: 10px;
      background: rgba(2, 2, 2, 0.6);
		}
		div	{
			padding: 10px;
		}
	}
	.is-center {
		background-position: center center !important;
	}
	.is-top {
		background-position: center top !important;		
	}
	.rectangle {
		background-size: cover !important;
		// filter: grayscale(100%);
		background-repeat:no-repeat !important;
		margin: 0 auto !important;
		&:hover {
			@media (min-width: 770px) {
				// filter: grayscale(0%);
				transition: ease .5s all;
			}
		}
	}
	.colored {
		@media (min-width: 770px) {
			// filter: grayscale(0%);
		}
	}
	.title {
		text-transform: capitalize;
		word-break: keep-all;
	}
	.absolute {
		bottom: 0px;
	}
	.content-style {
		padding: 30px;
		padding-bottom: 20px;
		width: 90%;
		@media (max-width: 770px) {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			display: flex;
			justify-content: center;
			align-items: center;
			h2 {
				font-size: 2.6rem !important;
				color: white !important;
				text-align: center;
			}
		}
	}
	.subtitle {
		opacity: 0;
		max-height: 0px;
		transition: .75s ease all;
    overflow: hidden;
    padding: 0px 10px;
	}
	.hide {
    h2, div {
      background: rgba(2, 2, 2, 0.6);
      transition: .75s ease all;
    }
		.subtitle {
      background: rgba(2, 2, 2, 0.6);
			opacity: 1 !important;
			transition: .75s ease all;
			max-height: 200px;
			// margin-bottom: 100px;
		}
	}
	button {
		z-index: 8;
		border: 0px;
		filter: grayscale(0%) !important;
		position: absolute !important;
		right: 20px;
		bottom: 20px;
		border-radius: 50%;
		padding-left: .9em;
		padding-right: .9em;
		height: 2.4em;
		// font-size: 1.3rem;
	}
</style>


// WEBPACK FOOTER //
// card.vue?11f647eb